const state = {
  phpLoaded: false,
  mode: "cli",
  code: "",
  controller: "",
  view: "",
  output: "",
  savedHash: "",
  deletePassword: "",
  font: "Fira Code",
  theme: "Dracula",
  phpBinaryDetected: false,
  lineNumbers: true,
  lineWrapping: true,
  lineHeight: 1.9,
  fontSize: 17,
  autoEvaluate: false,
  isDirty: false,
  showDocumentation: false,
};

const mutations = {
  setPHPLoaded(state, payload) {
    state.phpLoaded = payload;
  },
  setPreference(state, payload) {
    state[payload.key] = payload.value;
  },
  setCode(state, payload) {
    state.code = payload;
  },
  setIsDirty(state, payload) {
    state.isDirty = payload;
  },
  setOutput(state, payload) {
    state.output = payload;
  },
  setMode(state, payload) {
    state.mode = payload;
  },
  setController(state, payload) {
    state.controller = payload;
  },
  setView(state, payload) {
    state.view = payload;
  },
  showDocumentation(state, payload) {
    state.showDocumentation = payload;
  },
  setSavedHash(state, payload) {
    state.savedHash = payload;
  },
  loadSnippet(state, payload) {
    if (payload.mode === "http") {
      state.controller = payload.controllerCode;
      state.view = payload.viewCode;
    } else {
      state.code = payload.cliCode;
    }

    state.showDocumentation = false;
  },
  tryCodeFromDocumentation(state, payload) {
    if (payload.mode === "http") {
      state.controller = payload.controllerCode;
      state.view = payload.viewCode;
    } else {
      state.code = payload.cliCode;
    }

    state.showDocumentation = false;
  }
};

const actions = {
  setPHPLoaded(context, payload) {
    context.commit("setPHPLoaded", payload);
  },
  setPreference(context, payload) {
    context.commit("setPreference", payload);
  },
  setCode(context, payload) {
    context.commit("setCode", payload);
  },
  setIsDirty(context, payload) {
    context.commit("setIsDirty", payload);
  },
  setOutput(context, payload) {
    context.commit("setOutput", payload);
  },
  setController(context, payload) {
    context.commit("setController", payload);
  },
  setView(context, payload) {
    context.commit("setView", payload);
  },
  showDocumentation(context, payload) {
    context.commit("showDocumentation", payload);
  },
  setSavedHash(context, payload) {
    context.commit("setSavedHash", payload);
  },
  tryCodeFromDocumentation(context, payload) {
    context.commit("setMode", payload.mode);
    setTimeout(() => {
      context.commit("tryCodeFromDocumentation", payload);
    }, 150);
  },
  loadSnippet(context, payload) {
    context.commit("setMode", payload.mode);
    setTimeout(() => {
      context.commit("loadSnippet", payload);
    }, 150);
  },
};

export default {
  state,
  mutations,
  actions
};
